import { render } from "./HeroAuthTitleHeader.vue?vue&type=template&id=a08b87e6&scoped=true"
const script = {}

import "./HeroAuthTitleHeader.vue?vue&type=style&index=0&id=a08b87e6&scoped=true&lang=css"

import exportComponent from "/Users/alvinvergara/Developer/Lead Dev - Projects/DAP/iwc_dap/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a08b87e6"]])

export default __exports__